import { render, staticRenderFns } from "./HandoffPage.vue?vue&type=template&id=853c533c"
import script from "./HandoffPage.vue?vue&type=script&lang=js"
export * from "./HandoffPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports